/**
 * visit.lmp is Preg&Lac status from the dropdown — only '', '0'..'4'.
 * Legacy rows may store the Thai label (or free text), which breaks POST /visits/.
 */

export const VISIT_LMP_CODES = ['0', '1', '2', '3', '4']

export const VISIT_LMP_ITEMS = [
  { text: 'ไม่มีข้อมูล', value: '' },
  { text: 'ไม่ได้ตั้งครรภ์', value: '0' },
  { text: 'สงสัยตั้งครรภ์ หรือ อายุครรภ์น้อยกว่า 4 เดือน', value: '1' },
  { text: 'อายุครรภ์ 4 ถึง 7 เดือน', value: '2' },
  { text: 'อายุครรภ์มากกว่า 7 เดือน', value: '3' },
  { text: 'ระหว่างให้นมบุตร', value: '4' }
]

const LMP_TEXT_TO_CODE = {
  'ไม่มีข้อมูล': '',
  'ไม่ได้ตั้งครรภ์': '0',
  'ไม่ตั้งครรภ์/ไม่ให้นม': '0',
  'สงสัยตั้งครรภ์ หรือ อายุครรภ์น้อยกว่า 4 เดือน': '1',
  'ตั้งครรภ์': '1',
  'อายุครรภ์ 4 ถึง 7 เดือน': '2',
  'อายุครรภ์มากกว่า 7 เดือน': '3',
  'ตั้งครรภ์และให้นมบุตร': '3',
  'ระหว่างให้นมบุตร': '4',
  'ให้นมบุตร': '4'
}

function asTrimmedString (raw) {
  if (raw == null) return ''
  return String(raw).trim()
}

/**
 * True when the value is already a dropdown code (or empty). Labels/free text are invalid.
 * @param {*} raw
 * @returns {boolean}
 */
export function isValidVisitLmpCode (raw) {
  if (raw == null) return true
  const s = asTrimmedString(raw)
  return s === '' || VISIT_LMP_CODES.indexOf(s) !== -1
}

/**
 * Coerce stored lmp to an allowed dropdown code. Unknown text becomes ''.
 * @param {*} raw
 * @returns {string}
 */
export function normalizeVisitLmp (raw) {
  if (raw == null || raw === '') return ''
  if (typeof raw === 'object') {
    if (Object.prototype.hasOwnProperty.call(raw, 'value') && raw.value != null && isValidVisitLmpCode(raw.value)) {
      return normalizeVisitLmp(raw.value)
    }
    if (Object.prototype.hasOwnProperty.call(raw, 'text')) {
      return normalizeVisitLmp(raw.text)
    }
    if (Object.prototype.hasOwnProperty.call(raw, 'value')) {
      return normalizeVisitLmp(raw.value)
    }
    return ''
  }
  const s = asTrimmedString(raw)
  if (s === '') return ''
  if (VISIT_LMP_CODES.indexOf(s) !== -1) return s
  if (Object.prototype.hasOwnProperty.call(LMP_TEXT_TO_CODE, s)) {
    return LMP_TEXT_TO_CODE[s]
  }
  return ''
}

/**
 * Return a shallow copy with lmp normalized when the field is present.
 * @param {object} visit
 * @returns {object}
 */
export function applyValidVisitLmp (visit) {
  if (!visit || typeof visit !== 'object' || Array.isArray(visit)) return visit
  if (!Object.prototype.hasOwnProperty.call(visit, 'lmp')) return visit
  return { ...visit, lmp: normalizeVisitLmp(visit.lmp) }
}
